import { all, call, put, takeLatest, select } from 'redux-saga/effects';

import { request } from '@app/services';
import * as endpoints from './endpoints';
import {
  getMyTaksDetailsFailed,
  getMyTaskDetails,
  getMyTaskDetailsSuccess,
  getMyTasks,
  getMyTasksFailed,
  getMyTasksSuccess,
  updateTaskStatus,
  updateTaskStatusFailed,
  updateTaskStatusSuccess,
} from './slice';
import { RootState } from '@app/redux/root-reducer';

function* getMyTasksSaga(action: ReturnType<typeof getMyTasks>): any {
  const {
    userId,
    project,
    search,
    startDate,
    endDate,
    assignee,
    board,
    limit = 100,
    page = 1,
  } = action.payload;
  try {
    // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
    const result = yield call(
      request.get,
      `${endpoints.getTasks}${userId}?project=${project ?? ''}&search=${search ?? ''}&startDate=${
        startDate ?? ''
      }&endDate=${endDate ?? ''}&assignee=${assignee ?? ''}&board=${
        board ?? ''
      }&limit=${limit}&page=${page}`
    );
    yield put(getMyTasksSuccess(result.data));
  } catch (err) {
    yield put(getMyTasksFailed(err));
  }
}
//
function* getMyTaskDetailsSaga(action: ReturnType<typeof getMyTaskDetails>): any {
  try {
    const { boardId, listId, cardId, userId } = action.payload;
    const result = yield call(
      request.get,
      `${endpoints.getMyTaskDetails}${userId}/${boardId}/${listId}/${cardId}`
    );
    yield put(getMyTaskDetailsSuccess(result.data));
  } catch (err) {
    yield put(getMyTaksDetailsFailed(err));
  }
}
//
function* updateTaskStatusSaga(action: ReturnType<typeof updateTaskStatus>): any {
  try {
    const { data } = yield select((store: RootState) => store.myTasksReducer.myTasks);

    const { boardId, existingListId, cardId, newListId } = action.payload;
    const result = yield call(
      request.put,
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      `${endpoints.updateTaskStatus}${boardId}/${existingListId}/${cardId}/listId`,
      {
        newListId,
      }
    );
    yield put(updateTaskStatusSuccess(result.data));
    const updatedTasks = data?.tasks?.map((task: { id: number; listId: number }) => {
      if (task.id === cardId) {
        return {
          ...task,
          listId: newListId,
        };
      }
      return task;
    });
    yield put(getMyTasksSuccess({ tasks: updatedTasks }));
  } catch (err) {
    yield put(updateTaskStatusFailed(err));
  }
}

function* myTasksSagas() {
  yield all([
    takeLatest(getMyTasks, getMyTasksSaga),
    takeLatest(getMyTaskDetails, getMyTaskDetailsSaga),
    takeLatest(updateTaskStatus, updateTaskStatusSaga),
  ]);
}
export { myTasksSagas };
